import React, { useState, useEffect } from "react";
import useStyles from "./style";
import { useHistory } from "react-router-dom";
import config from "../../config";

// components
import { CircularProgress } from "@material-ui/core";
import Modal from "../modals/Modal";
import {
    TextField, Select, FormControl, MenuItem, Table, TableRow, TableHead,
    TableBody, TableCell
} from "@material-ui/core";
import { Delete, Add } from "@material-ui/icons";

export default function PayMembership() {
    const classes = useStyles();
    let history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [change, setChange] = useState(0.00);
    const [partnerValid, setPartnerValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [totalPay, setTotalPay] = useState(localStorage.getItem('totalPay'));
    const [subtotal, setSubtotal] = useState(localStorage.getItem('subtotal'));
    const [discount, setDiscount] = useState(localStorage.getItem('discount'));
    const [groupType, setGroupType] = useState(localStorage.getItem('groupType'));
    const [partnerId, setPartnerId] = useState(localStorage.getItem('partnerId'));
    const [isForOneDay, setIsForOneDay] = useState(localStorage.getItem('isForOneDay'));
    const [payment, setPayment] = useState([]);
    const [allPaymentMethods, setAllPaymentMethods] = useState([]);
    const [keyChange, setKeyChange] = useState(0);
    const [paymentIndex, setPaymentIndex] = useState(0);
    const [tableKey, setTableKey] = useState(0);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const fetchPaymentMethods = async () => {
        if (!showModal) {
            fetch(baseUrl + "paymentMethod",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error != null) {
                        setShowModal(true);
                    } else {
                        setAllPaymentMethods(data);
                    }
                })
                .catch(error => null);
        }
    }

    useEffect(() => {
        fetchPaymentMethods();
    }, []);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);
        var list = [];
        var listPayment = [];

        list.push({
            id: partnerId, price: subtotal, type: "Partner", amount: 1, discount: discount, isForOneDay: isForOneDay == "true" ? true : false
        });

        for (var q = 0; q < payment.length; q++) {
            var itemPaymentList = payment[q];

            listPayment.push({
                paymentMethod: itemPaymentList.paymentMethod, cash: Number(itemPaymentList.cash),
                transactionNumber: Number(itemPaymentList.transactionNumber), transactionCash: Number(itemPaymentList.transactionCash)
            });
        }

        const sale = {
            idUser: localStorage.getItem('idUserSystem'), subTotal: subtotal, discount: discount, totalToPay: totalPay, change: change,
            productSaleList: list, salePayment: listPayment
        };

        const response = await fetch(baseUrl + "createSale", {
            method: 'POST',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(sale)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.removeItem("totalPay");
            localStorage.removeItem("subtotal");
            localStorage.removeItem("discount");
            localStorage.removeItem("groupType");
            localStorage.removeItem("partnerId");
            history.goBack();
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }

        setIsLoading(false);
    }

    const handleChange = (idPayment) => (e) => {
        const value = e.target.value;
        var newPayment;
        var indexOfPayment;
        var newPaymentList = payment;
        for (var i = 0; i < payment.length; i++) {
            var itemPayment = payment[i];

            if (itemPayment.id == idPayment) {
                newPayment = {
                    id: itemPayment.id,
                    paymentMethod: value,
                    cash: itemPayment.cash,
                    transactionNumber: itemPayment.transactionNumber,
                    transactionCash: itemPayment.transactionCash
                };
                indexOfPayment = payment.indexOf(itemPayment);
            }
        }

        newPaymentList[indexOfPayment] = newPayment;
        setPayment(newPaymentList);
        setKeyChange(keyChange + 1);
    }

    const onChange = (paymentMethod, idPayment) => (e) => {
        let start = e.target.selectionStart;
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;

        if (val.length > 0) {
            e.target.value = Number(value).toFixed(2);
            e.target.setSelectionRange(start, start);
            var newPayment;
            var indexOfPayment;
            var newPaymentList = payment;

            for (var i = 0; i < payment.length; i++) {
                var itemPayment = payment[i];

                if (itemPayment.id == idPayment) {
                    if (paymentMethod == 'Efectivo') {
                        newPayment = {
                            id: itemPayment.id,
                            paymentMethod: itemPayment.paymentMethod,
                            cash: Number(value).toFixed(2),
                            transactionNumber: '',
                            transactionCash: ''
                        };
                    } else {
                        newPayment = {
                            id: itemPayment.id,
                            paymentMethod: itemPayment.paymentMethod,
                            cash: '',
                            transactionNumber: '',
                            transactionCash: Number(value).toFixed(2)
                        };
                    }
                    indexOfPayment = payment.indexOf(itemPayment);
                }
            }

            newPaymentList[indexOfPayment] = newPayment;
            setPayment(newPaymentList);
        }
        setKeyChange(keyChange + 1);
    }

    const onChangeTransaction = (idPayment) => (e) => {
        var newPayment;
        var indexOfPayment;
        var newPaymentList = payment;

        for (var i = 0; i < payment.length; i++) {
            var itemPayment = payment[i];

            if (itemPayment.id == idPayment) {
                newPayment = {
                    id: itemPayment.id,
                    paymentMethod: itemPayment.paymentMethod,
                    cash: itemPayment.cash,
                    transactionNumber: e.target.value,
                    transactionCash: itemPayment.transactionCash
                };
                indexOfPayment = payment.indexOf(itemPayment);
            }
        }

        newPaymentList[indexOfPayment] = newPayment;
        setPayment(newPaymentList);
        setKeyChange(keyChange + 1);
    }

    const onDelete = (idPayment) => e => {
        e.preventDefault();
        var index = -1;
        payment.map((item) => {
            if (item.id == idPayment) {
                index = payment.indexOf(item);
            }
        });

        if (index > -1) {
            var list = [];
            for (var i = 0; i < payment.length; i++) {
                var item = payment[i];
                if (index != i) {
                    list.push(item);
                }
            }

            var change = 0;
            var total = Number(totalPay);
            var valid;

            for (var q = 0; q < list.length; q++) {
                var itemPaymentList = list[q];

                if (itemPaymentList.paymentMethod == 'Efectivo') {
                    total = (Number(total) - Number(itemPaymentList.cash));
                } else {
                    total = (Number(total) - Number(itemPaymentList.transactionCash));
                }
            }

            change = Number(total) * -1;

            if (change >= 0.00) {
                change = Number(change);
                valid = true;
            } else {
                change = 0.00;
                valid = false;
            }

            setChange(change);
            setPartnerValid(valid);
            setKeyChange(keyChange + 1);
            setPayment(list);
        }

        setTableKey(tableKey + 1);
    }

    const onAddPayment = e => {
        var newPayment = {
            id: paymentIndex,
            paymentMethod: "",
            cash: null,
            transactionNumber: null,
            transactionCash: null
        }

        var paymentList = payment;
        paymentList.push(newPayment);

        setKeyChange(keyChange + 1);
        setPayment(paymentList);
        setPaymentIndex(paymentIndex + 1);
    }

    function calculateTotal() {
        var newList = payment;
        var change = 0;
        var total = Number(totalPay);
        var valid;

        for (var q = 0; q < payment.length; q++) {
            var itemPaymentList = payment[q];

            if (itemPaymentList.paymentMethod == 'Efectivo') {
                total = (Number(total) - Number(itemPaymentList.cash));
            } else {
                total = (Number(total) - Number(itemPaymentList.transactionCash));
            }
        }

        change = Number(total) * -1;

        if (change >= 0.00) {
            change = Number(change);
            valid = true;
        } else {
            change = 0.00;
            valid = false;
        }

        setChange(change);
        setPartnerValid(valid);
        setPayment(newList);
        setKeyChange(keyChange + 1);
    }

    return (
        <>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}

            <div className={classes.div} key={tableKey}>
                <div className={classes.divColumn}>
                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>Grupo de membrecía: </label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>{groupType}</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>Subtotal:</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>{"$ " + subtotal}</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>Descuento:</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>{"$ " + discount}</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>Total a pagar:</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>{"$ " + totalPay}</label>
                    </div>
                </div>

                <Table className="mb-0">
                    <TableHead>
                        <TableRow className={classes.rootTable} >
                            <TableCell>Método</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            {/*{keys.map(key => (
                                <TableCell key={key}>{key}</TableCell>
                            ))}*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payment.map(({ id, paymentMethod, cash, transactionNumber, transactionCash }) => (
                            <TableRow>
                                <TableCell className={classes.tableRowStyleTitle} >
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            onChange={handleChange(id)}
                                            displayEmpty
                                            style={{ color: "#FFFFFF" }}
                                            value={paymentMethod}
                                        >
                                            <MenuItem value=""> Selecciona </MenuItem>
                                            {allPaymentMethods.map((option) => (
                                                <MenuItem value={option.name}>{option.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell className={classes.tableRowStyleTitle} >
                                    <p style={{ fontSize: "16px" }}> CANTIDAD </p>
                                    <div style={{ display: "flex" }}>
                                        <p style={{ fontSize: "16px", marginTop: "8px" }}> $ </p>
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorder,
                                                    input: classes.inputPayGroup,
                                                },
                                            }}
                                            value={paymentMethod != "Efectivo" && paymentMethod != "" ? transactionCash : cash}
                                            onChange={onChange(paymentMethod, id)}
                                            placeholder={"0"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            onKeyUp={calculateTotal}
                                            onBlur={calculateTotal}
                                            style={{ width: '75%' }}
                                            inputStyle={{ width: '75%' }}
                                        />
                                    </div>
                                </TableCell>
                                {paymentMethod != "Efectivo" && paymentMethod != "" ? (
                                    <TableCell className={classes.tableRowStyleTitle} >
                                        <p style={{ fontSize: "16px" }}> # TRANSACCIÓN </p>
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorder,
                                                    input: classes.inputPayGroup,
                                                },
                                            }}
                                            value={transactionNumber}
                                            onChange={onChangeTransaction(id)}
                                            placeholder={"0"}
                                            disabled={paymentMethod == "Efectivo" ? true : false}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            onKeyUp={calculateTotal}
                                            onBlur={calculateTotal}
                                            style={{ width: '75%' }}
                                            inputStyle={{ width: '75%' }}
                                        />
                                    </TableCell>
                                ) : (
                                    <>
                                        <TableCell className={classes.tableRowStyleTitle} />
                                    </>
                                )}
                                <TableCell className={classes.tableRowStyleTitle}>
                                    <div className={classes.divActionButtonDisable} >
                                        <Delete
                                            classes={{ root: classes.searchIcon }}
                                            onClick={onDelete(id)}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell className={classes.tableRowStyleTitle} >
                                <div className={classes.divAddButton}>
                                    <Add classes={{ root: classes.searchIcon }}
                                        onClick={onAddPayment}
                                    />
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <div className={classes.divColumn}>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>Cambio:</label>
                    </div>

                    <div className={classes.divPayTitle}>
                        <label className={classes.payTitleStyle}>{"$ " + change}</label>
                    </div>
                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <div className={classes.loginLoader} >
                            <CircularProgress size={26} />
                        </div>
                    ) : (
                        <button
                            className={partnerValid == true ?
                                classes.enableButton : classes.disableButton}
                            disabled={!(partnerValid == true)}
                            onClick={onSubmit}
                        >Pagar</button>
                    )}
                </div>
            </div>
        </>
    );
}